import { render } from "./popupInputModel.vue?vue&type=template&id=380373c8"
import script from "./popupInputModel.vue?vue&type=script&lang=js"
export * from "./popupInputModel.vue?vue&type=script&lang=js"

import "./popupInputModel.vue?vue&type=style&index=0&id=380373c8&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__